if( ! document.getElementById("employer-account-detail") ) {
    return;
}

const validatePassword = (password) => {
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,20}$/;
    return regex.test(password);
};

const validateEmail = (email) => {
    return String(email)
    .toLowerCase()
    .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
};
    
const confirmUpdate = document.querySelector('.custom-message-modal-btn.confirm');
const confirmBtnCancel = document.querySelector('.custom-message-modal-btn.btn-delete.cancel');

if (confirmUpdate) confirmUpdate.style.display = 'none';
if (confirmBtnCancel) confirmBtnCancel.style.display = 'none';

const modal = document.querySelector('.custom-message-modal-overlay');
const modalTitle = document.querySelector('.custom-message-modal-title');
const modalBodyText = document.querySelector('.custom-message-modal-body');
const modalFooter = document.querySelector('.custom-message-modal-footer');
const modalTriggerBtn = document.querySelector('.open-modal-btn');
const modalCross = document.querySelector('.custom-message-modal-close');

if (modalFooter) modalFooter.innerHTML = '';

// if (modal) {
//     modal.addEventListener('click', function(e) { 
//         if (e.target.classList.contains('custom-message-modal-overlay')) {
//             modal.classList.remove('d-flex');
//             e.target.remove();
//         }
//     });
// }

function employerAccountDetailModal(message, title='Attention Required') {
    if (modalTitle) modalTitle.innerHTML = title;
    if (modalBodyText) modalBodyText.innerHTML = '';
    if (modalBodyText) modalBodyText.innerHTML = message;

    const modalElement = document.querySelector('.custom-message-modal-overlay');
    if( modalElement ) modalElement.classList.add('processing');
    if( modalCross ) modalCross.style.display = 'none';
    
    // Show modal
    if (modalTriggerBtn) modalTriggerBtn.click();
}

const employerAccountDetail = document.getElementById("employer-account-detail");
employerAccountDetail.addEventListener("submit", function(event) {
    event.preventDefault();
    let passwordChange = false;
    let nameChange = false;
    
    const errorElements = document.querySelectorAll('.err');
    if(errorElements) errorElements.forEach(el => el.remove());
    
    if(document.querySelector('.custom-message-modal-btn.updated')) {
        document.querySelector('.custom-message-modal-btn.updated').remove();
    }

    const currentPassword = document.getElementById("current-password").value.trim();
    const newPassword = document.getElementById("new-password").value.trim();
    const confirmPassword = document.getElementById("confirm-password").value.trim();

    if (currentPassword || newPassword || confirmPassword) {
        if (!currentPassword || !newPassword || !confirmPassword) {
            // employerAccountDetailModal("<p>If you are attempting to change password, all password fields are required.</p>");
            // if( modalCross ) modalCross.style.display = 'block';
            
            const p = document.createElement('p');
            p.className = 'err';
            p.textContent = 'If you are attempting to change password, all password fields are required.';
            document.getElementById("current-password").after(p);
            document.querySelector('#email').scrollIntoView({ behavior: 'smooth' });
            return;
        }
        
        if( ! validatePassword(newPassword) ) {
            // employerAccountDetailModal('<p>Password must be at least 8-20 characters and include uppercase, lowercase, number, and special character</p>');
            // if( modalCross ) modalCross.style.display = 'block';
            
            const p = document.createElement('p');
            p.className = 'err';
            p.textContent = 'Password must be at least 8-20 characters, uppercase, lowercase, number, and special character';
            document.getElementById("new-password").after(p);
            document.querySelector('#email').scrollIntoView({ behavior: 'smooth' });
            return;
        }
        
        if( newPassword !== confirmPassword ) {
            // employerAccountDetailModal("<p>Confirm password did not matched</p>");
            // if( modalCross ) modalCross.style.display = 'block';
            
            const p = document.createElement('p');
            p.className = 'err';
            p.textContent = 'Confirm password did not matched';
            document.getElementById("confirm-password").after(p);
            document.querySelector('#email').scrollIntoView({ behavior: 'smooth' });
            return;
        }
        passwordChange = true;
    }

    const firstName = document.getElementById("first-name").value.trim();
    const lastName = document.getElementById("last-name").value.trim();
    const contactNumber = document.getElementById("contactNumber").value.trim();

    const sellerEmail = document.getElementById("seller-email").value.trim();
	
    const oldFirstName = document.getElementById("first-name").getAttribute('data-firstname').trim(); 
    const oldLastName = document.getElementById("last-name").getAttribute('data-lastname').trim(); 
    const oldContactNumber = document.getElementById("contactNumber").getAttribute('data-contactnumber').trim();

    nameChange = (firstName !== oldFirstName) || (lastName !== oldLastName) || (contactNumber !== oldContactNumber);

    const errors = [];

    if (firstName === '') {
        errors.push({ message: 'First name is required', scrollDiv: '.pages-employer-account_detail', attrId: 'first-name' });
    } else {
        const nameRegex = /^[a-zA-Z\s]{2,50}$/;
        if (!nameRegex.test(firstName)) {
            errors.push({ message: 'First name must include alphabets of minimum 2 to maximum 50', scrollDiv: '.pages-employer-account_detail', attrId: 'first-name' });
        }
    }
    if (lastName === '') {
        errors.push({ message: 'Last name is required', scrollDiv: '.pages-employer-account_detail', attrId: 'last-name' });
    } else {
        const nameRegex = /^[a-zA-Z\s]{2,50}$/;
        if (!nameRegex.test(lastName)) {
            errors.push({ message: 'Last name must include alphabets of minimum 2 to maximum 50', scrollDiv: '.pages-employer-account_detail', attrId: 'last-name' });
        }
    }
    if (contactNumber === '') {
        // errors.push({ message: 'Contact number is required', scrollDiv: '.dashboard-content-header', attrId: 'contactNumber' });
    } else if (!/^\d{10}$/.test(contactNumber)) {
        errors.push({ message: 'Please enter a valid 10-digit phone number', scrollDiv: '.dashboard-content-header', attrId: 'contactNumber' });
    }
    if (sellerEmail === '') {
        errors.push({ message: 'Seller email is required', scrollDiv: '.pages-employer-account_detail', attrId: 'seller-email' });
    } else {
        if(!validateEmail(sellerEmail)) {
            errors.push({ message: 'Enter valid email', scrollDiv: '.pages-employer-account_detail', attrId: 'seller-email' });

        }
    }

    if (errors.length > 0) {
        errors.forEach(error => {
            const errID = document.getElementById(error.attrId);
            const errMessage = error.message;
            if (errID) {
                const p = document.createElement('p');
                p.className = 'err';
                p.textContent = errMessage;

                if (error.attrId === 'contactNumber') {
                    const formElement = errID.closest('.form-element');
                    if (formElement) {
                        formElement.appendChild(p);
                    } else {
                        // fallback if .form-element not found
                        errID.after(p);
                    }
                } else {
                    errID.after(p);
                }
            }
        });

        // employerAccountDetailModal('<p>Please fill in all necessary details to proceed.</p>');
        
        const target = document.querySelector(errors[0].scrollDiv);
        if (target) target.scrollIntoView({ behavior: 'smooth' });
        return;
    }

    const formData = new FormData(employerAccountDetail);    
    formData.append('nameChange', nameChange);
    formData.append('passwordChange', passwordChange);

	formData.append('action', 'employer_employee_account_detail');
	formData.append('nonce', ajax_callback_data.ajax_nonce);
	
    employerAccountDetailModal('<p>Applying account update...</p>', 'Please wait');

    fetch(ajax_callback_data.ajax_url, {
		method: 'POST',
		body: formData
	})
    .then(response => response.json())
    .then(data => {
        if( data.success ) {
            employerAccountDetailModal(`<p>${data.data.message}</p>`, 'Confirmation');
            document.querySelector('.dashboard--profile').scrollIntoView({ behavior: 'smooth' });
            window.location.reload();
        } else {
            if( data.data.type && (data.data.type=='password') ) {
                const p = document.createElement('p');
                p.className = 'err';
                p.textContent = data.data.message;
                document.getElementById("current-password").after(p);
                document.querySelector('#email').scrollIntoView({ behavior: 'smooth' });
                if( modalCross ) modalCross.click();
                
            } else {
                employerAccountDetailModal(`<p>${data.data.message}</p>`);
                if( modalCross ) modalCross.style.display = 'block';
            }
        }
    })
    .catch(error => {
        console.error('Error:', error);
        employerAccountDetailModal('<p>Something went wrong. Try again.</p>');
    });
});